import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux'
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from 'react-router-dom';

import { updateLoginStatus } from './store/userSlice'
import { fetchStations } from './store/stationsSlice'
import { NavigationBar } from './components/NavigationBar';
import { Footer } from './components/Footer';
import { Home } from './components/pages/Home';
import { Intro } from './components/pages/intro';
import { Observatory } from './components/pages/observatory';
import { Data } from './components/pages/data';
import { OpenApi } from './components/pages/openapi';
import { SeismicAnalysis } from './components/pages/analysis';
import { NotFound } from './components/pages/NotFound';

import './assets/css/main.css'

const LoginCallBack = () => {
  // alert('Closing the window')
  window.close();
  // return <h2>Closing the window</h2>
  <Redirect to="/" />
}


function App() {  
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchStations())
    dispatch(updateLoginStatus())
  }, [])
  return (
    <Router basename="/quake">
      <NavigationBar/>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/intro">
          <Intro />
        </Route>
        <Route path="/observatory">
          <Observatory />
        </Route>
        <Route path="/data">
          <Data />
        </Route>
        <Route path="/openapi">
          <OpenApi />
        </Route>
        <Route path="/analysis">
          <SeismicAnalysis />
        </Route>
        <Route path="/sso-login-callback">
          <LoginCallBack />
        </Route>
        <Route component={ NotFound } />
      </Switch>      
      <Footer />
    </Router>
  );
}

export default App;
